import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ChevronDoubleUpFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M12 3.44L19.36 10.8L17.94 12.22L12 6.28L6.06 12.22L4.64 10.8L12 3.44ZM12 11.02L19.36 18.38L17.94 19.8L12 13.86L6.06 19.8L4.64 18.38L12 11.02Z" />
    </SvgIcon>
  );
});
